import { useTranslation } from 'react-i18next';
import styles from './LanguageSwitcher.module.css';

interface LanguageSwitcherProps {
  scrolled?: boolean;
}

export const LanguageSwitcher = ({ scrolled = false }: LanguageSwitcherProps) => {
  const { i18n } = useTranslation();

  const langs = ['it', 'en'] as const;

  return (
    <div className={`${styles.switcher} ${scrolled ? styles.switcherScrolled : ''}`}>
      {langs.map((lng) => (
        <button
          key={lng}
          onClick={() => i18n.changeLanguage(lng)}
          className={`${styles.lang} ${scrolled ? styles.langScrolled : ''} ${
            i18n.language === lng ? styles.active : ''
          }`}
        >
          {lng}
        </button>
      ))}
    </div>
  );
};
